/**
 * Base routing module of the application.
 */

import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './core/services/auth-guard.service';
import { LinkedinAuthComponent } from './modules/users/components/linkedin-auth/linkedin-auth.component';

// Define the routes

const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./modules/pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'uikit',
    loadChildren: () => import('./modules/uikit/uikit.module').then(m => m.UikitModule)
  },
  {
    path: 'users',
    loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'session',
    loadChildren: () => import('./modules/session/session.module').then(m => m.SessionModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./modules/theme/app-theme.module').then(m => m.AppThemeModule)
  },
  { path: 'callback', pathMatch: 'full', component: LinkedinAuthComponent },
  {
    path: 'share',
    loadChildren: () => import('./modules/share-recording/share-recording.module').then(m => m.ShareRecordingModule)
  },

  {
    path: '', pathMatch: 'full', redirectTo: '/users/login'
  },

  { path: '**', redirectTo: '/app/not-found' }

];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
